export default ['amex', 'diners', 'discover', 'jcb', 'mastercard', 'unionpay', 'visa'];
